import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateContainerTypeGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  payload: Types.UpdateContainerTypeGroupInput;
}>;


export type UpdateContainerTypeGroupMutation = { __typename?: 'Mutation', updateContainerTypeGroup: boolean };


export const UpdateContainerTypeGroupDocument = gql`
    mutation UpdateContainerTypeGroup($id: Int!, $payload: UpdateContainerTypeGroupInput!) {
  updateContainerTypeGroup(id: $id, payload: $payload)
}
    `;
export type UpdateContainerTypeGroupMutationFn = Apollo.MutationFunction<UpdateContainerTypeGroupMutation, UpdateContainerTypeGroupMutationVariables>;

/**
 * __useUpdateContainerTypeGroupMutation__
 *
 * To run a mutation, you first call `useUpdateContainerTypeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContainerTypeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContainerTypeGroupMutation, { data, loading, error }] = useUpdateContainerTypeGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateContainerTypeGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContainerTypeGroupMutation, UpdateContainerTypeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContainerTypeGroupMutation, UpdateContainerTypeGroupMutationVariables>(UpdateContainerTypeGroupDocument, options);
      }
export type UpdateContainerTypeGroupMutationHookResult = ReturnType<typeof useUpdateContainerTypeGroupMutation>;
export type UpdateContainerTypeGroupMutationResult = Apollo.MutationResult<UpdateContainerTypeGroupMutation>;
export type UpdateContainerTypeGroupMutationOptions = Apollo.BaseMutationOptions<UpdateContainerTypeGroupMutation, UpdateContainerTypeGroupMutationVariables>;